var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, width: "430", persistent: "" } },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _vm._v(" Confirm " + _vm._s(_vm.move ? "Move" : "Copy") + " "),
          ]),
          _c(
            "v-card-text",
            [
              _vm._v(" " + _vm._s(_vm.confirmText) + " "),
              _vm.move
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 px-0 pb-0 d-inline-flex",
                      attrs: { cols: "auto" },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { color: "warning" } },
                        [_vm._v("mdi-alert")]
                      ),
                      _c("strong", [
                        _vm._v(
                          " Moving this feature will clear its content in this location. "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  class: _vm.body,
                  attrs: { color: "grey darken-1", text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("cancel")
                    },
                  },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  class: _vm.body,
                  attrs: { color: _vm.move ? "warning" : "success" },
                  on: { click: _vm.confirm },
                },
                [_vm._v(" Continue ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }